// src/types/insuranceCompany.ts

/**
 * label: 화면에 보일 보험사 이름
 * value: 2자리 코드 (string)
 */
export interface InsuranceCompanyOption {
  label: string
  value: string
}

export type InsuranceCompanyCode = InsuranceCompanyOption["value"]

export const DEFAULT_INSURANCE_COMPANY_OPTIONS: InsuranceCompanyOption[] = [
  { label: "메리츠화재", value: "01" },
  { label: "한화손보", value: "02" },
  { label: "롯데손보", value: "03" },
  { label: "MG손보", value: "04" },
  { label: "흥국화재", value: "05" },
  { label: "삼성화재", value: "08" },
  { label: "현대해상", value: "09" },
  { label: "KB손보", value: "10" },
  { label: "DB손보", value: "13" },
  { label: "AIG손보", value: "17" },
  { label: "전국택시공제조합", value: "21" },
  { label: "전국버스공제조합", value: "22" },
  { label: "전국화물자동차공제조합", value: "23" },
  { label: "전국개인택시공제조합", value: "24" },
  { label: "전국전세버스공제조합", value: "25" },
  { label: "배달서비스공제조합", value: "28" },
  { label: "전국렌터카공제조합", value: "30" },
  { label: "AXA손보", value: "41" },
  { label: "하나손보", value: "42" },
  { label: "신한EZ손보", value: "43" },
  { label: "현대해상하이카다이렉트", value: "45" },
  { label: "캐롯손보", value: "69" },
  { label: "자동차손해배상진흥원", value: "93" },
  { label: "에이스아메리칸화재", value: "98" },
  { label: "미군공제(USAA)", value: "99" },
] as const satisfies InsuranceCompanyOption[]

export const HIRA_ONLINE_GUARANTEE_COMPANY_CODES = [
  "01",
  "02",
  "03",
  "04",
  "05",
  "08",
  "09",
  "10",
  "13",
  "41",
  "42",
  "69",
] as const satisfies InsuranceCompanyCode[]

const HIRA_ONLINE_GUARANTEE_COMPANY_CODE_SET = new Set<string>(HIRA_ONLINE_GUARANTEE_COMPANY_CODES)

export const HIRA_ONLINE_GUARANTEE_COMPANY_OPTIONS = DEFAULT_INSURANCE_COMPANY_OPTIONS.filter(option =>
  HIRA_ONLINE_GUARANTEE_COMPANY_CODE_SET.has(option.value)
)

export const isHiraOnlineGuaranteeSupportedCompanyCode = (code?: string | null) => {
  return HIRA_ONLINE_GUARANTEE_COMPANY_CODE_SET.has(String(code || ""))
}

// 주의: 기존 코드 호환을 위해 동일 식별자를 유지하되, 런타임 갱신 가능하도록 mutable 배열로 유지
export const INSURANCE_COMPANY_OPTIONS: InsuranceCompanyOption[] = [...DEFAULT_INSURANCE_COMPANY_OPTIONS]

export const setInsuranceCompanyOptions = (options: InsuranceCompanyOption[]) => {
  if (!options.length) return

  INSURANCE_COMPANY_OPTIONS.splice(0, INSURANCE_COMPANY_OPTIONS.length, ...options)
}

export const resetInsuranceCompanyOptions = () => {
  INSURANCE_COMPANY_OPTIONS.splice(0, INSURANCE_COMPANY_OPTIONS.length, ...DEFAULT_INSURANCE_COMPANY_OPTIONS)
}
